<section
  *ngIf="kpiCardsData.length; else serviceDetailsKpiSkeletonLoader"
  id="service-details-kpi"
  class="flex flex-col w-full box-border fade-in"
  [ngClass]="
    !validPeriod ? 'p-4 bg-neptune-disabled gap-4 rounded-lg' : 'bg-white'
  "
>
  <div
    id="not-applicable-message"
    *ngIf="!validPeriod"
    class="flex gap-1 px-3 py-1 items-center justify-start bg-mocassin self-center w-fit rounded-lg"
  >
    <img
      class="w-5 h-5"
      alt="info-icon"
      src="assets/shared-icons/neptune-icon-blue-info.svg"
    />
    <span class="text-base font-medium">
      These KPI's are not available when custom date ranges or Year to Date is
      selected
    </span>
  </div>
  <section id="service-details-kpi-cards-container" class="flex w-full gap-6">
    <div
      *ngFor="let card of kpiCardsData"
      id="kpi-card-{{ card.period }}"
      class="kpi-card flex flex-col flex-1 px-4 py-4 gap-1 border-1 border-solid border-sky-blue bg-neptune-color-primary-50 rounded-lg"
    >
      <span
        class="kpi-period text-shuttle-gray text-sm justify-start items-center"
      >
        {{ cardLabel[card.period] }}
      </span>
      <section class="kpi-body flex gap-2 justify-start items-center">
        <span class="kpi-value text-2xl font-medium">
          {{
            card.metricTotal != null
              ? (card.metricTotal | number: "1.0-0")
              : "N/A"
          }}
        </span>
        <div
          class="flex items-center justify-center"
          *ngIf="card.percentageChange"
        >
          <img
            src="/assets/shared-icons/neptune-icon-blue-solid-chevron-down.svg"
            alt="Chevron Down"
            class="w-5 h-5"
            [ngClass]="card.percentageChange >= 0 ? 'rotate-180' : ''"
          />
          <span
            class="kpi-percentage-change text-sm text-neptune-color-primary-500 font-medium"
          >
            {{ card.percentageChange | signedNumber }}%
          </span>
        </div>
      </section>
    </div>
  </section>
</section>

<ng-template #serviceDetailsKpiSkeletonLoader>
  <section class="flex w-full gap-6" id="serviceDetailsKpiSkeletonLoader">
    <div
      *ngFor="let _ of [1, 2, 3, 4]"
      class="flex flex-col flex-1 px-4 py-4 gap-3 border border-solid border-sky-blue bg-neptune-color-primary-50 rounded-lg"
    >
      <!-- Period Label -->
      <div class="h-4 w-20 bg-neptune-subtle rounded animate-pulse"></div>

      <!-- KPI Value + Percentage -->
      <div class="flex items-center gap-2">
        <div class="h-8 w-16 bg-neptune-subtle rounded animate-pulse"></div>
        <div class="h-5 w-10 bg-neptune-subtle rounded animate-pulse"></div>
      </div>
    </div>
  </section>
</ng-template>
